import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import {makeStyles} from '@material-ui/core/styles';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(200),
    },
  },
}));

export default function CustomizedSnackbars(props) {
  const classes = useStyles();
  const {alert, onClose} = props;

  return (
    <div className={classes.root}>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={typeof alert === 'string'}
        autoHideDuration={3000}
        onClose={onClose}>
        <Alert onClose={onClose} severity="error">
          {alert}
        </Alert>
      </Snackbar>
    </div>
  );
}
